// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*,
*::before,
*::after {
  box-sizing: border-box;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

.form-inline {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  width: 100%;
}
.form-inline .keyword-container {
  display: flex;
  width: 875px;
}
.form-inline input[type=text] {
  height: 36px;
  width: 200px;
}
.form-inline .clear-container {
  border-radius: 0 5px 5px 0;
  background-color: #EDf0F1;
  border: 1px solid #D1D3D4;
  contain: content;
  height: 36px;
  padding: 0 5px;
  width: 36px;
}
.form-inline button.keyword-clear {
  margin-top: -10px;
}
.form-inline button.keyword-clear span {
  font-size: 1.8rem;
  margin-left: -5px;
  z-index: 1200;
}`, "",{"version":3,"sources":["webpack://./src/styles/global/Colors.scss","webpack://./src/styles/FacetedSearch.scss","webpack://./src/styles/global/globalMixins.scss"],"names":[],"mappings":"AAAA;;;EAGI,sBAAA;ACCJ;;ADJA;;;EAGI,sBAAA;ACOJ;;AAPA;EACI,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,WAAA;AAUJ;AATI;EACI,aAAA;EACA,YAAA;AAWR;AATI;EACI,YAAA;EACA,YAAA;AAWR;AATI;ECbA,0BDc0B;EACtB,yBAAA;EACA,yBAAA;EACA,gBAAA;EACA,YAAA;EACA,cAAA;EACA,WAAA;AAWR;AATI;EACI,iBAAA;AAWR;AAVQ;EACI,iBAAA;EACA,iBAAA;EACA,aAAA;AAYZ","sourcesContent":["*,\n*::before,\n*::after {\n    box-sizing: border-box;\n}\n$lt-blue: #7DB7CC;\n$information: #00AEEF;\n$information-hover: #02BFFF;\n$text: #414042;\n$white: #EDEDED;\n$shadow: #525151;\n$red: #CB321A;\n$green: #C7CC68;\n$DCSD-logo-green: #84ae30;\n$dashboard-blue: #0d6efd;\n$dk-blue: #0A4064;\n$important: #FEBF31;\n$highlight: #FDF9D0;\n$grey0: #EDf0F1;\n$grey1: #D1D3D4;\n$grey2: #A7A9AC;\n$grey3: #808080;\n$grey3a: #707070;\n$grey4: #636161;\n$grey4a: #444343;\n$grey5: #333;\n$pale-blue: #C0DEF0;\n$pearl-dk-blue: #0762a7;\n$pearl-blue: #0669B3;\n$pearl-blue-hover: #1786DB;\n$lt-pearl-blue: #63AEDE;\n$lt-pearl-blue-hover: #4589B3;\n$teal-logo: #46A8B0;\n\n$pale-blue-green: #9acdd2;\n$pale-blue-green-outline: #75c2c9;\n\n$pale-purple: #bca0d3;\n$pale-purple-outline: #946eb4;\n","@import \"../styles/global/Colors\";\n@import \"../styles/global/globalMixins\";\n\n.form-inline {\n    display: flex;\n    flex-direction: row;\n    justify-content: flex-start;\n    width: 100%;\n    .keyword-container {\n        display: flex;\n        width: 875px;\n    }\n    input[type=\"text\"] {\n        height: 36px;\n        width: 200px;\n    }\n    .clear-container {\n        @include borderRadius(0 5px 5px 0);\n        background-color: $grey0;\n        border: 1px solid $grey1;\n        contain: content;\n        height: 36px;\n        padding: 0 5px;\n        width: 36px\n    }\n    button.keyword-clear {\n        margin-top: -10px;\n        span {\n            font-size: 1.8rem;\n            margin-left: -5px;\n            z-index: 1200;\n        }\n    }\n}\n","@import \"./Colors.scss\";\n\n@mixin borderRadius($radius: 5px) {\n    border-radius: $radius;\n}\n\n@mixin dialogueBold() {\n    font-weight: 600;\n    font-size: .9em;\n}\n\n@mixin input() {\n    border-radius: 5px;\n    font-weight: 400;\n    width: 100%;\n}\n\n@mixin infoRounded($radius) {\n    background: $information;\n    border-bottom-left-radius: $radius;\n    border-bottom-right-radius: $radius;\n}\n\n@mixin shadow() {\n    box-shadow: 0.1rem 0.15rem 0.3rem 0 $shadow;\n}\n@mixin shadowBottom() {\n    box-shadow: 0 0.1rem 0.15rem 0 $shadow;\n}\n@mixin standardInputContainer() {\n    font-weight: 500;\n    font-size: .9rem;\n    margin: 10px 0;\n}\n@mixin standardInput() {\n    @include borderRadius(5px);\n    border: none;\n    border: 1px solid $grey3;\n    padding: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
